import { useDevice } from "../../useDevice";
import Box from "../Box";
import { MilestonesTimeline } from "./MilestonesTimeline";
import { ProgressInsightsSection } from "./ProgressInsightsSection";
import type { Milestone, MiniStat } from "./types";

type Props = {
	miniStats: MiniStat[];
	milestones: Milestone[];
};

export const StatsTabContent = ({ miniStats, milestones }: Props) => {
	const { isMobile } = useDevice();

	return (
		<Box
			gap={24}
			paddingHorizontal={isMobile ? 16 : 0}
			paddingTop={24}
			paddingBottom={24}
		>
			<ProgressInsightsSection miniStats={miniStats} />
			<MilestonesTimeline milestones={milestones} />
		</Box>
	);
};
